import { Drawer } from '@cleartax/wg-library-drawer';
import { useApi } from '@cleartax/wg-library-hooks';
import { Text } from '@cleartax/wg-library-typography';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useUserCtx } from '../../../../../../context/user';
import { logoutApi, TLogoutRes } from '../../header.api';
import { MY_ACCOUNT_DROPDOWN } from '../../my-account-dropdown/static';
import { MY_TOOLS_DROPDOWN } from '../static';
import { SidebarDropDown } from './sidebar-dropdown';

interface ISidebar {
  open: boolean;
  closeCB: (state: boolean) => void;
}
export const HamburgerSidebar: React.FC<ISidebar> = ({ open, closeCB }) => {
  const userContext = useUserCtx();
  const router = useRouter();
  const returnPath = Buffer.from(router.asPath as string).toString('base64');

  const { request: logout, data: logoutRes } = useApi<TLogoutRes>(
    {},
    logoutApi
  );

  useEffect(() => {
    if (logoutRes.success) userContext.logout();
  }, [logoutRes]);

  return (
    <Drawer
      onCloseCallBack={() => closeCB(false)}
      isOpen={open}
      direction={'right'}
      width={'3/4'}
      minWidth={300}
      animationDuration={500}
      top={'48px'}
      hideIcon={true}
      closeOnClickOverlay
    >
      {userContext.isLoggenIn ? (
        <SidebarDropDown
          contentHeader="My Account"
          contentArr={MY_ACCOUNT_DROPDOWN}
          onClickCB={logout}
        />
      ) : (
        <Text
          type="a"
          href={`${process.env.NEXT_PUBLIC_SSO_ENDPOINT}&return_path=${returnPath}`}
          mergeClasses="override"
          className="block border-b-sm border-b-grey-300 border-dashed pl-3 text-base text-brand-1000 font-semibold py-5"
        >
          Login/Register
        </Text>
      )}
      <Text
        type="a"
        href="https://www.clear.in/s/contact-us"
        mergeClasses="override"
        className="block border-b-sm border-b-grey-300 border-dashed pl-3 text-base text-brand-1000 font-semibold py-5"
      >
        Support
      </Text>
      <SidebarDropDown contentHeader="Tools" contentArr={MY_TOOLS_DROPDOWN} />
    </Drawer>
  );
};
